import React from 'react';
import { DateTime } from 'luxon';
import { QText, useCurrentUser } from '@qualio/ui-components';

type DueColumnProps = {
  dueDate: string;
  closedAtDatetime?: DateTime;
  isInFinalStatuses?: boolean;
};

const DueColumnV2: React.FC<DueColumnProps> = ({ dueDate, closedAtDatetime, isInFinalStatuses }) => {
  const { formatDate } = useCurrentUser();
  const dueDateEndOfDay = DateTime.fromFormat(dueDate, 'yyyy-MM-dd').endOf('day').toMillis();

  // reference today for colour coding
  const today = DateTime.now().endOf('day').toMillis();

  const breachingDueDateTimeStamp =
    closedAtDatetime && isInFinalStatuses ? closedAtDatetime?.endOf('day').toMillis() : today;

  const textColor = dueDateEndOfDay < breachingDueDateTimeStamp && !isInFinalStatuses ? 'red.500' : 'gray.800';
  return (
    <QText color={textColor}>
      {formatDate(DateTime.fromFormat(dueDate, 'yyyy-MM-dd', { zone: 'utc' }).toString())}
    </QText>
  );
};

export default DueColumnV2;
